module.exports = __webpack_public_path__ + "static/img/snowFlakeLogo.c563901d.png";